/* RESPONSIBLE TEAM: team-standalone */
import {
  EXTERNAL_CONTENT,
  FILE_CONTENT,
  TEXT_CONTENT,
  ZENDESK_ARTICLE_SYNC_CARD,
} from 'embercom/lib/ai-content-library/constants';

import { type AiContentLibraryData } from './definitions';

export const GenericAiContentLibraryData: AiContentLibraryData = {
  templates: [TEXT_CONTENT, FILE_CONTENT, EXTERNAL_CONTENT, ZENDESK_ARTICLE_SYNC_CARD],
};

export const SalesforceAiContentLibraryData: AiContentLibraryData = {
  templates: [EXTERNAL_CONTENT, FILE_CONTENT, TEXT_CONTENT, ZENDESK_ARTICLE_SYNC_CARD],
};

export const ZendeskAiContentLibraryData: AiContentLibraryData = {
  templates: [ZENDESK_ARTICLE_SYNC_CARD, EXTERNAL_CONTENT, FILE_CONTENT, TEXT_CONTENT],
};
